<template>
  <div class="login-container">
    <div class="login-card">
      <h2 class="login-title">Blooming Rice 系統登入</h2>
      <p class="login-subtitle">安全登入以存取您的帳戶</p>

      <button @click="handleLogin" class="login-button" :disabled="isLoading">
        <span v-if="!isLoading">使用 OAuth2 安全登入</span>
        <span v-else>登入中...</span>
      </button>

      <p class="login-note">
        <small>此登入方式使用 OAuth2 + PKCE 標準協議，確保您的帳戶安全。</small>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useAuth } from '@/composables/useAuth';

const { loginWithOAuth2 } = useAuth();

const isLoading = ref(false);

const handleLogin = async () => {
  try {
    isLoading.value = true;

    // APP 專用：使用 OAuth2 流程
    await loginWithOAuth2();
  } catch (error) {
    console.error('登入失敗:', error);
    alert('登入失敗，請稍後再試');
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
  text-align: center;
}

.login-title {
  color: #333;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
}

.login-subtitle {
  color: #666;
  font-size: 14px;
  margin-bottom: 32px;
}

.login-button {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.login-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-note {
  margin-top: 24px;
  color: #999;
}

.login-note small {
  font-size: 12px;
}
</style>
